// adds a peaman to the last Sunday of each month for two years
export default function addPeamans(peamanData, events, cancelledPeamans) {
  const cancelledDates = [];
  for (let i = 0; i < cancelledPeamans.length; i++) {
    const cancelledDate = new Date(cancelledPeamans[i]);
    cancelledDates.push([
      cancelledDate.getFullYear(),
      cancelledDate.getMonth(),
      cancelledDate.getDate(),
    ]);
  }
  const date = new Date();
  let month = date.getMonth();
  let monthsAdded = 0;
  let peamanDate;
  while (monthsAdded < 24) {
    if (date.getMonth() !== month) {
      if (peamanDate) {
        let cancelled = false;
        for (let i = 0; i < cancelledDates.length; i++) {
          if (
            peamanDate.getFullYear() === cancelledDates[i][0] &&
            peamanDate.getMonth() === cancelledDates[i][1] &&
            peamanDate.getDate() === cancelledDates[i][2]
          )
            cancelled = true;
        }
        if (!cancelled) {
          const newEvent = {};
          newEvent.year = peamanDate.getFullYear();
          newEvent.month = peamanDate.getMonth();
          newEvent.day = peamanDate.getDate();
          newEvent.name = peamanData.name;
          newEvent.description = peamanData.description;
          newEvent.location = peamanData.location;
          newEvent.startHour = parseInt(peamanData.time.slice(11, 13));
          newEvent.startMinutes = parseInt(peamanData.time.slice(14, 16));
          events.push(newEvent);
        }
        monthsAdded++;
      }
      month = date.getMonth();
    }
    if (date.getDay() === 0) peamanDate = new Date(date.getTime());
    date.setDate(date.getDate() + 1);
  }
}
